<div class="content-container main-font">
  <div class="delta-container">
    <div class="card-details-container">
      <p class="mb-0 title-details">VELOCITY PERSONALE</p>
      <div class="card-details">
        <div class="user-container">
          <img
            [src]="utilityService.getSanitizeUrl(userMonitoring.path)"
            alt="user"
            class="image" />
          <div class="stats-container">
            <div class="reviews-container">
              <div class="last-review">
                <p class="mb-0 text-review">Ultima review</p>
                <p class="mb-0 text-velocity">
                  {{ userMonitoring.user_velocity.last_velocity }}
                </p>
              </div>
              <div class="current-review">
                <p class="mb-0 text-review">Review attuale</p>
                <p class="mb-0 text-velocity">
                  {{ userMonitoring.user_velocity.current_velocity }}
                </p>
              </div>
            </div>
            <div class="delta-percentage-container">
              <p class="mb-0 text-review delta">Delta percentuale</p>
              <div class="percentage-container g-16">
                <p
                  class="mb-0 text-velocity"
                  [ngClass]="{
                    'text-velocity-positive':
                      userMonitoring.user_velocity.delta > 0,
                    'text-velocity-negative':
                      userMonitoring.user_velocity.delta < 0
                  }">
                  {{ userMonitoring.user_velocity.delta }}%
                </p>
                <img
                  *ngIf="userMonitoring.user_velocity.delta != 0"
                  [src]="
                    userMonitoring.user_velocity.delta < 0
                      ? 'assets/images/icon_widget/arrow_negative.svg'
                      : 'assets/images/icon_widget/arrow_positive.svg'
                  "
                  alt="arrow" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-details-container">
      <p class="mb-0 title-details">VELOCITY AZIENDALE</p>
      <div class="card-details">
        <div class="user-container">
          <img
            src="assets/images/default_images/darwin-logo.png"
            alt="darwin"
            class="image-darwin" />
          <div class="stats-container">
            <div class="reviews-container">
              <div class="last-review">
                <p class="mb-0 text-review">Ultima review</p>
                <p class="mb-0 text-velocity">
                  {{ userMonitoring.company_velocity.last_velocity }}
                </p>
              </div>
              <div class="current-review">
                <p class="mb-0 text-review">Review attuale</p>
                <p class="mb-0 text-velocity">
                  {{ userMonitoring.company_velocity.current_velocity }}
                </p>
              </div>
            </div>
            <div class="delta-percentage-container">
              <p class="mb-0 text-review delta">Delta percentuale</p>
              <div class="percentage-container g-16">
                <p
                  class="mb-0 text-velocity"
                  [ngClass]="{
                    'text-velocity-positive':
                      userMonitoring.company_velocity.delta > 0,
                    'text-velocity-negative':
                      userMonitoring.company_velocity.delta < 0
                  }">
                  {{ userMonitoring.company_velocity.delta }}%
                </p>
                <img
                  *ngIf="userMonitoring.company_velocity.delta != 0"
                  [src]="
                    userMonitoring.company_velocity.delta < 0
                      ? 'assets/images/icon_widget/arrow_negative.svg'
                      : 'assets/images/icon_widget/arrow_positive.svg'
                  "
                  alt="arrow" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="projects-container">
    <div class="project-container">
      <div class="project-position my-scrollbar">
        <table class="w-100">
          <thead>
            <tr class="sticky-top header-background">
              <th class="header-text padding-cell">Progetto</th>
              <th class="text-center header-text padding-cell">
                Ultima review
              </th>
              <th class="text-center header-text padding-cell">
                Review attuale
              </th>
              <th class="text-center header-text padding-cell">
                Delta percentuale
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let project of userMonitoring.user_velocity
                  .project_user_velocity
              ">
              <td class="padding-cell">
                <div class="user-cell">
                  <img
                    [src]="utilityService.getSanitizeUrl(project.path)"
                    [alt]="project.alias"
                    class="first-img"
                    [nz-tooltip]="project.alias" />
                  <img
                    [src]="utilityService.getSanitizeUrl(userMonitoring.path)"
                    alt="user"
                    class="second-img" />
                </div>
              </td>
              <td class="padding-cell text-center">
                <p class="mb-0">
                  {{ project.last_velocity }}
                </p>
              </td>
              <td class="padding-cell text-center">
                <p class="mb-0">
                  {{ project.current_velocity }}
                </p>
              </td>
              <td class="padding-cell text-center">
                <div nz-row class="percentage-container">
                  <p
                    nz-col
                    nzSpan="10"
                    class="mb-0 text-table"
                    [ngClass]="{
                      'text-velocity-positive': project.delta > 0,
                      'text-velocity-negative': project.delta < 0
                    }">
                    {{ project.delta }}%
                  </p>
                  <img
                    nz-col
                    nzSpan="4"
                    *ngIf="project.delta != 0"
                    class="icon-table"
                    [src]="
                      project.delta < 0
                        ? 'assets/images/icon_widget/arrow_negative.svg'
                        : 'assets/images/icon_widget/arrow_positive.svg'
                    "
                    alt="arrow" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="project-container">
      <div class="project-position my-scrollbar">
        <table class="w-100">
          <thead>
            <tr class="sticky-top header-background">
              <th class="header-text padding-cell">Progetto</th>
              <th class="text-center header-text padding-cell">
                Ultima review
              </th>
              <th class="text-center header-text padding-cell">
                Review attuale
              </th>
              <th class="text-center header-text padding-cell">
                Delta percentuale
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let project of userMonitoring.company_velocity
                  .project_user_velocity
              ">
              <td class="padding-cell">
                <div class="user-cell">
                  <img
                    src="assets/images/default_images/darwin-logo.png"
                    alt="user"
                    class="first-img object-fit-contain"
                    [nz-tooltip]="project.alias" />
                  <img
                    [src]="utilityService.getSanitizeUrl(project.path)"
                    [alt]="project.alias"
                    class="second-img" />
                </div>
              </td>
              <td class="padding-cell text-center">
                <p class="mb-0">
                  {{ project.last_velocity }}
                </p>
              </td>
              <td class="padding-cell text-center">
                <p class="mb-0">
                  {{ project.current_velocity }}
                </p>
              </td>
              <td class="padding-cell text-center">
                <div nz-row class="percentage-container">
                  <p
                    nz-col
                    nzSpan="10"
                    class="mb-0 text-table"
                    [ngClass]="{
                      'text-velocity-positive': project.delta > 0,
                      'text-velocity-negative': project.delta < 0
                    }">
                    {{ project.delta }}%
                  </p>
                  <img
                    nz-col
                    nzSpan="4"
                    *ngIf="project.delta != 0"
                    class="icon-table"
                    [src]="
                      project.delta < 0
                        ? 'assets/images/icon_widget/arrow_negative.svg'
                        : 'assets/images/icon_widget/arrow_positive.svg'
                    "
                    alt="arrow" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
